import { CircularProgress } from "@mui/material";
import { useAnalyseMutation } from "../../api";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "hooks/useReduxHooks";
import { setIsNotificationsOpen, setStatus } from "../../features/companySlice";
import { SSEEvents } from "../../types/companyTypes";
import { GoToActionBlock } from "../products";
import { GradientButton } from "./GradientButton";
import { selectPermissions } from "../../features/permissionsSlice";

export const AnalyseCompanyDataBlock = ({
  account_id,
  successCallBack,
  status,
  progress,
  isDisabled,
  campaign_id,
  title,
  text,
  onAnalysisStart,
}: {
  account_id: string;
  title: string;
  text: string[];
  successCallBack: () => void;
  status: string;
  progress: number;
  isDisabled: boolean;
  campaign_id: string;
  onAnalysisStart?: () => void;
}) => {
  const dispatch = useAppDispatch();
  const [isAnalyse, setIsAnalyse] = useState<boolean>(false);
  const [currentProgress, setCurrentProgress] = useState<number>(progress);

  const { analysis_status } = useAppSelector((state) => state.company.status);
  const { isAllowedEditLaunchAccountAnalysis } =
    useAppSelector(selectPermissions);

  const [analyse, { isSuccess, isLoading }] = useAnalyseMutation();

  useEffect(() => {
    if (analysis_status?.account_id !== account_id) return;
    setCurrentProgress(analysis_status.progress);
  }, [analysis_status]);

  useEffect(() => {
    if (["in_progress", "queued"].includes(status)) setIsAnalyse(true);
  }, [status]);

  useEffect(() => {
    if (isSuccess) {
      setIsAnalyse(true);
      successCallBack();
      dispatch(setIsNotificationsOpen(true));
    }
  }, [isSuccess]);

  useEffect(() => {
    return () => {
      dispatch(setStatus({ [SSEEvents.scraping_status]: undefined }));
      dispatch(setStatus({ [SSEEvents.scraping_update_status]: undefined }));
      dispatch(setStatus({ [SSEEvents.analysis_status]: undefined }));
    };
  }, []);

  const analyseHandler = () => {
    if (isLoading || isAnalyse) return;
    onAnalysisStart?.();
    analyse({ account_ids: [account_id], campaign_id });
  };

  return (
    <GoToActionBlock
      title={title}
      texts={text}
      btn={
        <GradientButton
          onClick={analyseHandler}
          disabled={
            isDisabled ||
            isLoading ||
            isAnalyse ||
            !isAllowedEditLaunchAccountAnalysis
          }
        >
          {isLoading || isAnalyse ? (
            <>
              <CircularProgress size={24} sx={{ color: "inherit" }} />
              Analysis in Progress:{" "}
              <span style={{ minWidth: "20px" }}>{currentProgress}%</span>
            </>
          ) : (
            <>Analyze Account Data</>
          )}
        </GradientButton>
      }
    />
  );
};
